import { todayISO } from "../../lib/format";

export const QUOTE_KIND = { preventivo: "Preventivo", capitolato: "Capitolato", altro: "Altro documento economico" };
export const VARIATION_KIND = { modifica: "Modifica lavorazioni", extra_cliente: "Richiesta extra cliente", imprevisto: "Spesa imprevista" };
export const VARIATION_STATUS = { in_attesa: "In attesa di approvazione", approvata: "Approvata", respinta: "Respinta" };
export const PURCHASE_KIND = { acquisto: "Acquisto materiale", spesa_extra: "Spesa extra / imprevisto" };
export const INVOICE_KIND = { acconto: "Acconto", sal: "SAL", saldo: "Saldo", fattura: "Fattura" };
const CATEGORIES = ["Materiali edili", "Ferro e acciaio", "Calcestruzzo", "Impianti", "Noleggi", "Trasporti",
  "Smaltimento rifiuti", "Subappalti", "Permessi e oneri", "Imprevisti", "Altro"];
export const PAY_METHODS = ["Bonifico", "Contanti", "Assegno", "Ri.Ba.", "Carta", "Compensazione"];

export const STATUS_CLS = {
  approvata: "bg-emerald-950 border-emerald-600 text-emerald-200",
  in_attesa: "bg-amber-950 border-amber-600 text-amber-200",
  respinta: "bg-slate-800 border-slate-600 text-slate-300",
};

export const optionEntries = (o) => (Array.isArray(o) ? o.map((x) => [x, x]) : Object.entries(o));

const notes = { key: "notes", label: "Note", type: "textarea", wide: true };

export const SECTIONS = {
  variations: {
    title: "Varianti in corso d'opera", add: "Nuova variante", empty: "Nessuna variante registrata",
    fields: [
      { key: "var_date", label: "Data", type: "date", required: true },
      { key: "kind", label: "Tipo", type: "select", options: VARIATION_KIND },
      { key: "description", label: "Descrizione", required: true, wide: true },
      { key: "amount", label: "Importo € (negativo se riduce il valore)", type: "number", required: true },
      { key: "status", label: "Stato", type: "select", options: VARIATION_STATUS },
      notes,
    ],
    defaults: () => ({ var_date: todayISO(), kind: "modifica", status: "in_attesa" }),
    row: (r) => ({ date: r.var_date, title: r.description, subtitle: VARIATION_KIND[r.kind], badge: r.status, badgeLabel: VARIATION_STATUS[r.status] }),
  },
  purchases: {
    title: "Acquisti merce e spese di cantiere", add: "Nuovo costo", empty: "Nessun acquisto o spesa registrata",
    paymentsTitle: "Pagamenti al fornitore", paidLabel: "Pagato", residualLabel: "Da pagare",
    fields: [
      { key: "kind", label: "Tipo", type: "select", options: PURCHASE_KIND },
      { key: "purchase_date", label: "Data", type: "date", required: true },
      { key: "supplier", label: "Fornitore", required: true },
      { key: "category", label: "Categoria", type: "select", options: CATEGORIES },
      { key: "description", label: "Descrizione", required: true, wide: true },
      { key: "amount", label: "Importo €", type: "number", required: true },
      { key: "due_date", label: "Scadenza pagamento", type: "date" },
      { key: "payment_method", label: "Modalità di pagamento", type: "select", options: PAY_METHODS },
      notes,
    ],
    defaults: () => ({ kind: "acquisto", purchase_date: todayISO(), category: CATEGORIES[0], payment_method: PAY_METHODS[0] }),
    row: (r) => ({ date: r.purchase_date, title: `${r.supplier} · ${r.description}`, subtitle: `${PURCHASE_KIND[r.kind]} · ${r.category}`, due: r.due_date }),
  },
  invoices: {
    title: "Fatture e incassi dal cliente", add: "Nuovo importo da incassare", empty: "Nessun importo da incassare registrato",
    paymentsTitle: "Incassi ricevuti", paidLabel: "Incassato", residualLabel: "Da incassare",
    fields: [
      { key: "kind", label: "Tipo", type: "select", options: INVOICE_KIND },
      { key: "number", label: "Numero fattura" },
      { key: "issue_date", label: "Data", type: "date", required: true },
      { key: "due_date", label: "Scadenza", type: "date" },
      { key: "description", label: "Descrizione", required: true, wide: true },
      { key: "amount", label: "Importo €", type: "number", required: true },
      notes,
    ],
    defaults: () => ({ kind: "acconto", issue_date: todayISO() }),
    row: (r) => ({ date: r.issue_date, title: r.description, subtitle: `${INVOICE_KIND[r.kind]}${r.number ? ` n. ${r.number}` : ""}`, due: r.due_date }),
  },
};
